export enum DateType {
    Transaction = 1,
    Posting = 2
};